import styled from 'styled-components';


export const HexagonTextContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  font-weight: bold;
`;

export const StructureContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7rem;
  padding: 2rem;
  background: transparent;
`;

export const HexagonRow = styled.div`
  display: flex;
  gap: 5rem;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top:8.8rem;
`;

export const HexagonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: min(80vw, 28rem);
  height: 16rem;
  aspect-ratio: 2 / 1;
  background-color: transparent;
  margin: 10rem 0rem 5rem 0rem;
`;

export const HexagonInner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 7rem;
  position: relative;

  background-color: #1a8f3a;
  clip-path: polygon(
    50% 0%,
    93% 25%,
    93% 75%,
    50% 100%,
    7% 75%,
    7% 25%
  );
  

  @media (max-width: 600px) {
    padding: 5rem;
  }
`;


export const HexagonText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: white;
  text-align: center;
  font-weight: bold;
  white-space: pre-line;
  font-size: 0.9rem;
  line-height: 1.2rem;
  position: relative;

  @media (max-width: 600px) {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  &::after {
    content: '';
    display: block;
    height: 0.3rem;
    background-color: var(--sixth-color);
    border-radius: 0.5rem;
    margin: 0 auto;
    margin-top: 0.3rem;
    width: 5.25rem;
  }
`;


export const ConnectionLine = styled.div`
  position: relative;
  width: 100%;

  @media (max-width: 1870px) {
    display: none;
  }

  .line-vertical {
    position: absolute;
    left: 50%;
    top: 1.9;
    width: 0.2rem;
    height: 17.6rem;
    background-color: #1a8f3a;
    transform: translateX(-50%);
  }

  .line-horizontal {
    position: absolute;
    top: 14.8rem;
    left: 48%;
    width: 5rem;
    height: 0.2rem;
    background-color: #1a8f3a;
    transform: translateX(-50%);
  }

  .line-second-horizontal {
    position: absolute;
    top: 17.5rem;
    left: 52%;
    width: 5rem;
    height: 0.2rem;
    background-color: #1a8f3a;
    transform: translateX(-50%);
  }
`;

export const SmallHexagonWrapper = styled(HexagonWrapper)`
  width: min(80vw, 25rem);
  aspect-ratio: 2 / 1;
  margin-top: 1rem;
`;

export const SmallHexagonInner = styled(HexagonInner)`
  padding: 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  @media (max-width: 600px) {
    padding: 2.5rem;
  }
`;

export const SmallHexagonText = styled(HexagonText)`
  font-size: 0.8rem;
  line-height: 1.1rem;
  top: 2rem;
  width: 18rem;
  justify-content: center;
  align-items:center;
  gap:0.5rem;

  @media (max-width: 600px) {
    font-size: 0.7rem;
    line-height: 1rem;
  }
  &::after {
    display: none;
  }
`;

export const SmallHexagonWrapperE = styled(SmallHexagonWrapper)`
  position: relative;
  top: 0;
`;

export const SmallHexagonWrapperD = styled(SmallHexagonWrapper)`
  position: relative;
  top: -2vw;

  @media (max-width: 600px) {
    top: 0;
  }
`;
